const state = {
  callCenterGeneral: [],
  reservationsTimeoutAll: 0,
  listWorker: [],
  listTasks: [],
  listDetailCallCenter: [],
  chartWaitingCall: {}
}

const getters = {
  getCallCenterGeneral (state) {
    return state.callCenterGeneral
  },
  getTotalReservationsTimeoutAll (state) {
    return state.reservationsTimeoutAll
  },
  getListWorker (state) {
    return state.listWorker
  },
  getListWaitingCall (state) {
    return state.listTasks
  },
  getDataDetailCallCenter (state) {
    return state.listDetailCallCenter
  },
  getChartWatingCall (state) {
    return state.chartWaitingCall
  }
}

const mutations = {
  SET_CALL_CENTER_GENERAL (state, data) {
    state.callCenterGeneral = data
  },
  SET_TOTAL_RESERVATIONS_TIMEOUT (state, data) {
    state.reservationsTimeoutAll = data
  },
  SET_LIST_WORKER (state, data) {
    state.listWorker = data
  },
  SET_LIST_TASKS (state, data) {
    state.listTasks = data
  },
  SET_DETAIL_CALL_CENTER (state, data) {
    state.listDetailCallCenter = data
  },
  SET_CHART_WAITING_CALL (state, data) {
    state.chartWaitingCall = data
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
